export default {
    route:"https://profile-691e5.appspot.com/",
    twitter_user_id:"nogawanogawa",
    github_grass_url:"https://grass-graph.moshimo.works/images/nogawanogawa.png",
    github_url:"https://github.com/nogawanogawa",    
    this_repository_url:"https://github.com/nogawanogawa/profile_frontend",
    hatena_com_url:"https://www.nogawanogawa.com",
    hatena_work_url:"https://www.nogawanogawa.work",
    connpass_url:"https://connpass.com/user/nogawanogawa/",
    contact_url:"https://docs.google.com/forms/d/e/1FAIpQLSe_h6lgijbqEpBqjnA1n37qSVl9qCtdJOKCif3k_SmVxHgDiA/viewform",
    atcoder_url:"https://atcoder.jp/users/nogawanogawa",
    items:[
        {
            date: "2010/4 - 2014/3",
            title: "Mechanical engineering (Bachelor)",
            contents: ""
        },
        {
            date: "2014/4 - 2016/3",
            title: "Information science (Master)",
            contents: ""
        },
        {
            date: "2016/4 - 2017/11",
            title: "System engineer",
            contents: ""
        },
        {
            date: "2017/12 - 2021/7",
            title: "Consultant",
            contents: ""
        },
        {
            date: "2021/8 - ",
            title: "Data Scientist",
            contents: ""
        }
    ]
}

